export default __webpack_public_path__ + "static/designsForHealthLogo-8cbc798d1e65d0cd840e1e114b7a3daf.png";